import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './hooks/useAuth'
import Auth from './components/Auth'
import ForgotPassword from './components/ForgotPassword'
import ResetPassword from './components/ResetPassword'
import Header from './components/Header'
import TaskManager from './components/TaskManager'
import './App.css'

const AppContent = () => {
  const { user, loading } = useAuth()
  const [clock, setClock] = useState('')

  // Update clock every second
  useEffect(() => {
    const updateClock = () => {
      const now = new Date()
      const weekday = now.toLocaleDateString('en-US', { weekday: 'short' })
      const dateStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
      const timeStr = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`
      setClock(`${dateStr} ${weekday} ${timeStr}`)
    }

    updateClock()
    const interval = setInterval(updateClock, 1000)
    return () => clearInterval(interval)
  }, [])

  return (
    <Routes>
      <Route 
        path="/" 
        element={
          loading ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>Loading...</p>
            </div>
          ) : user ? (
            <>
              <Header clock={clock} />
              <TaskManager />
            </>
          ) : (
            <Auth />
          )
        } 
      />
      <Route 
        path="/forgot-password" 
        element={user ? <Navigate to="/" /> : <ForgotPassword />} 
      />
      <Route 
        path="/reset-password" 
        element={<ResetPassword />} 
      />
    </Routes>
  )
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <AppContent />
        </div>
      </Router>
    </AuthProvider>
  )
}

export default App